import { motion } from 'framer-motion';
import { useTheme } from '../context/ThemeContext';

const ThemeToggle = () => {
  const { isDarkMode, toggleTheme } = useTheme();

  return (
    <motion.button
      onClick={toggleTheme}
      className="relative inline-flex items-center justify-center w-12 h-6 rounded-full bg-gray-600 dark:bg-indigo-600 transition-colors duration-200"
      whileTap={{ scale: 0.95 }}
    >
      <div
        className={`absolute left-1 w-4 h-4 rounded-full bg-white transition-transform duration-200 ${
          isDarkMode ? 'translate-x-6' : 'translate-x-0'
        }`}
      />
      <span className="sr-only">Toggle theme</span>
    </motion.button>
  );
};

export default ThemeToggle;
